import React from "react";

const ExportIcon = props => (
  <svg width={19} height={18} {...props}>
    <g fill="#FFF" fillRule="evenodd">
      <path d="M9.035 12.107a.774.774 0 1 1 0-1.549h4.906V7.255H7.485a.775.775 0 0 1-.774-.774V.025H.774A.775.775 0 0 0 0 .8v15.49c0 .427.347.774.774.774h12.392a.774.774 0 00 .774-.775v-4.182H9.035z" />
      <path d="M18.944 11.257c0-.012-.003-.023-.004-.035l-.007-.04c-.002-.013-.006-.026-.01-.039l-.008-.035-.013-.037-.013-.034c-.004-.012-.01-.023-.015-.034l-.017-.035-.018-.031-.021-.034-.024-.033-.021-.028a.785.785 0 0 0-.05-.054l-.001-.003-1.937-1.936a.775.775 0 0 0-1.095 1.095l.614.615H13.94v1.548h2.364l-.614.615a.774.774 0 1 0 1.095 1.095l1.936-1.936.002-.002a.774.774 0 0 0 .05-.055l.02-.028.025-.033.02-.034.019-.03.017-.036.015-.034.013-.035c.005-.012.01-.024.013-.036l.009-.035.01-.039.006-.04.005-.035a.766.766 0 0 0 .003-.075v-.001-.001a.775.775 0 0 0-.004-.075zM13.487 5.705L8.26.48v5.226h3.035z" />
    </g>
  </svg>
);

export default ExportIcon;


// WEBPACK FOOTER //
// ./src/containers/CRM/AnalyticsData/ExportIcon.js